"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStatuses = void 0;
exports.ApplicationStatuses = {
    created: 'created',
    rejected: 'rejected',
    /** If applicant pressed not interested button / link from notification.
     * Or Dwellet staff updates status to notInterested based on followUp */
    notInterested: 'notInterested',
    accepted: 'accepted',
    /** if application press no availabe times button from reservation tool */
    noAvailableTimes: 'noAvailableTimes',
    /** Dwellet staff can set application to "manual" status when staff controls application process */
    manual: 'manual',
    showingReserved: 'showingReserved',
    /** Dwellet staff marks application to wantsContract status  */
    wantsContract: 'wantsContract',
    tenant: 'tenant'
};
//# sourceMappingURL=applications.js.map